import { useEffect } from 'react';

/**
Hook to load an SVG via fetch
and insert into dom
and also save to localStorage
*/
function useLocalStorageSVG({
  url,
  id,
  version
}) {
  useEffect(() => {
    if (!document.getElementById(id)) {
      const svgVersion = localStorage && localStorage.getItem(`${id}-version`) || null;
      const svgData = localStorage && localStorage.getItem(id) || null;
      if (!svgData || svgVersion !== `${version}`) {
        try {
          fetch(url).then(response => {
            if (!response.ok) {
              return '';
            }
            return response.text();
          }).then(svg => {
            document.body.insertAdjacentHTML('beforeend', svg);
            try {
              /* mobile safari in private mode always fails localStorage */
              localStorage.setItem(id, svg);
              localStorage.setItem(`${id}-version`, version);
            } catch (e) {
              /* so lint doesn't complain */
            }
          });
        } catch (e) {
          /* added so tests don't choke, we dont really support browsers that don't do fetch() */
        }
      } else {
        document.body.insertAdjacentHTML('beforeend', svgData);
      }
    }
  }, [id, url, version]);
}

/*
Fetches SVG symbol from CDN and places inline on page
Source for SVG symbol is "icons.svg"
Which is uploaded to the stipple/assets directory

Fetching instead of placing inline to leverage browser caching
And to reduce bundle size, since icons are one of the largest assets
for this package

*/

/**
 *
 * @deprecated since 3.0.0. Use individual Icon React components instead.
 * Component will be removed in the next major release.
 */
function IconSymbol() {
  const version = 17;
  useLocalStorageSVG({
    url: `https://screentone.dowjones.io/assets/icons.${version}.svg?src=st_iconsymbol`,
    id: 'st-icons',
    version
  });
  const brandVersion = 5;
  useLocalStorageSVG({
    url: `https://screentone.dowjones.io/assets/brands-logos.${brandVersion}.svg?src=st_iconsymbol`,
    id: 'st-brands-logos',
    version
  });
  return null;
}

export { IconSymbol as default };
